import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

/** Shared visual wrapper for static content pages (About / Contact / Privacy / Terms). */
export default function StaticPage({ title, subtitle, seoDescription, children }) {
  useEffect(() => {
    const prev = document.title;
    document.title = `${title} — ALFÀ`;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta ? meta.getAttribute('content') : null;
    if (meta && seoDescription) meta.setAttribute('content', seoDescription);
    return () => {
      document.title = prev;
      if (meta && prevDesc !== null) meta.setAttribute('content', prevDesc);
    };
  }, [title, seoDescription]);

  return (
    <>
      <Header />
      <main className="pt-24 sm:pt-28 pb-24 bg-gradient-to-b from-white via-orange-50/30 to-white">
        <section className="max-w-3xl mx-auto px-6">
          <h1
            data-testid="static-page-title"
            className="font-display uppercase text-[36px] sm:text-[48px] md:text-[60px] leading-[0.98] tracking-[-0.015em] text-[color:var(--alfa-navy)]"
          >
            {title}
          </h1>
          {subtitle && (
            <p className="mt-5 text-[17px] sm:text-[18px] text-neutral-950 leading-relaxed max-w-2xl">
              {subtitle}
            </p>
          )}
          <div className="mt-10 prose prose-neutral max-w-none prose-headings:font-display prose-headings:uppercase prose-headings:tracking-[-0.01em] prose-headings:text-[color:var(--alfa-navy)] prose-h2:text-[24px] sm:prose-h2:text-[28px] prose-h2:mt-10 prose-h2:mb-3 prose-p:text-[16.5px] prose-p:leading-[1.7] prose-li:text-[16.5px] prose-strong:text-neutral-950">
            {children}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
